import { DomSanitizer } from "@angular/platform-browser";
import { Block } from "./model/block.model";

export function getEventNcourKibo(sanitizer: DomSanitizer): Block[] {
    return [
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/N-Cour/Edm1.jpg",
            blockImgName: "",
            blockIndex: 0,
            blockName: "block0",
            blockType: 8,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/N-Cour/Edm2.jpg",
            blockImgName: "",
            blockIndex: 1,
            blockName: "block0",
            blockType: 8,
            content: null,
            id: 1,
            imgLink: "https://www.accupass.com/event/2503231319488770457060",
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/N-Cour/Edm3.jpg",
            blockImgName: "",
            blockIndex: -1,
            blockName: "block0",
            blockType: 8,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
    ];
}
